// extracted by mini-css-extract-plugin
export default {"stickyNav":"style_stickyNav__d5Gom"};